import { PROFILE_BODY_TYPE } from './body-type'
import { PROFILE_GOAL } from './goal'
import { defineMessages } from 'react-intl'

const PROFILE_CATEGORY_BMI = {
  UNDERWEIGHT: 1,
  NORMAL: 2,
  OVERWEIGHT: 3,
  OBESE_1: 4,
  OBESE_2: 5,
  OBESE_3: 6
}

const PROFILE_BMI_CATEGORY_TO_GOAL = {
  [PROFILE_CATEGORY_BMI.UNDERWEIGHT]: PROFILE_GOAL.BUILD_MUSCLE,
  [PROFILE_CATEGORY_BMI.NORMAL]: PROFILE_GOAL.GET_FIT,
  [PROFILE_CATEGORY_BMI.OVERWEIGHT]: PROFILE_GOAL.GET_FIT,
  [PROFILE_CATEGORY_BMI.OBESE_1]: PROFILE_GOAL.LOSE_WEIGHT,
  [PROFILE_CATEGORY_BMI.OBESE_2]: PROFILE_GOAL.LOSE_WEIGHT,
  [PROFILE_CATEGORY_BMI.OBESE_3]: PROFILE_GOAL.LOSE_WEIGHT
}

const PROFILE_BMI_CATEGORY_TO_BODY_TYPE = {
  [PROFILE_CATEGORY_BMI.UNDERWEIGHT]: PROFILE_BODY_TYPE.ECTOMORPH,
  [PROFILE_CATEGORY_BMI.NORMAL]: PROFILE_BODY_TYPE.MESOMORPH,
  [PROFILE_CATEGORY_BMI.OVERWEIGHT]: PROFILE_BODY_TYPE.MESO_ENDOMORPH,
  [PROFILE_CATEGORY_BMI.OBESE_1]: PROFILE_BODY_TYPE.ENDOMORPH,
  [PROFILE_CATEGORY_BMI.OBESE_2]: PROFILE_BODY_TYPE.ENDOMORPH,
  [PROFILE_CATEGORY_BMI.OBESE_3]: PROFILE_BODY_TYPE.ENDOMORPH
}

const PROFILE_BMI_CATEGORY_RANGES = {
  [PROFILE_CATEGORY_BMI.UNDERWEIGHT]: [
    0,
    18.49
  ],
  [PROFILE_CATEGORY_BMI.NORMAL]: [
    18.5,
    24.9
  ],
  [PROFILE_CATEGORY_BMI.OVERWEIGHT]: [
    25,
    29.9
  ],
  [PROFILE_CATEGORY_BMI.OBESE_1]: [
    30,
    34.9
  ],
  [PROFILE_CATEGORY_BMI.OBESE_2]: [
    35,
    39.9
  ],
  [PROFILE_CATEGORY_BMI.OBESE_3]: [
    40,
    500
  ]
}

const labels = defineMessages({
  underweight: {
    id: 'ProfileBMI.underweight',
    defaultMessage: 'Underweight',
    description: 'The label used for the underweight body type.'
  },
  normal: {
    id: 'ProfileBMI.normal',
    defaultMessage: 'Normal',
    description: 'The label used for the ecto-overweight body type.'
  },
  overweight: {
    id: 'ProfileBMI.overweight',
    defaultMessage: 'Overweight',
    description: 'The label used for the overweight body type.'
  },
  obese1: {
    id: 'ProfileBMI.obese1',
    defaultMessage: 'Obese 1',
    description: 'The label used for the meso endomorph body type.'
  },
  obese2: {
    id: 'ProfileBMI.obese2',
    defaultMessage: 'Obese 2',
    description: 'The label used for the meso endomorph body type.'
  },
  obese3: {
    id: 'ProfileBMI.Obese3',
    defaultMessage: 'Obese 3',
    description: 'The label used for the meso endomorph body type.'
  }
})

const PROFILE_BMI_CATEGORY_MESSAGE = {
  [PROFILE_CATEGORY_BMI.UNDERWEIGHT]: labels.underweight,
  [PROFILE_CATEGORY_BMI.NORMAL]: labels.normal,
  [PROFILE_CATEGORY_BMI.OVERWEIGHT]: labels.overweight,
  [PROFILE_CATEGORY_BMI.OBESE_1]: labels.obese1,
  [PROFILE_CATEGORY_BMI.OBESE_2]: labels.obese2,
  [PROFILE_CATEGORY_BMI.OBESE_3]: labels.obese3
}

export {
  PROFILE_CATEGORY_BMI,
  PROFILE_BMI_CATEGORY_MESSAGE,
  PROFILE_BMI_CATEGORY_TO_BODY_TYPE,
  PROFILE_BMI_CATEGORY_TO_GOAL,
  PROFILE_BMI_CATEGORY_RANGES
}
